import { Button } from "@mui/material";
import React from "react";
import { ReactOneDriveFilePicker } from "react-onedrive-filepicker/lib";

function OneDriveFilePicker(props) {
  const { filePickerButtonLabel, handleChosenFile } = props;
  return <>

    <ReactOneDriveFilePicker
      clientID={process.env.REACT_APP_ENTRA_AUTH_CLIENT_ID}
      action="share"
      multiSelect={false}
      openInNewWindow={true}
      onError={(err) => console.log(`Error: '${JSON.stringify(err)}'.`)}
      onSuccess={(fileData) => handleChosenFile(fileData)}
      onCancel={(result) => {
        console.log(`Cancelled: '${JSON.stringify(result)}'.`);
      }}>

      <Button
        id='select-file-btn'
        variant='contained'
        style={{ width: '150px' }}>
        {filePickerButtonLabel}
      </Button>

    </ReactOneDriveFilePicker>
  </>
}

export default OneDriveFilePicker;